import { useCurrentAppUser } from '@/hooks/useCurrentAppUser';
import { format } from 'date-fns';
import { safeFormat } from '@/lib/safeDate';
import { ptBR } from 'date-fns/locale';

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Bom dia';
  if (hour < 18) return 'Boa tarde';
  return 'Boa noite';
}

export function GreetingHeader() {
  const { data: appUser, isLoading } = useCurrentAppUser();
  
  const greeting = getGreeting();
  const today = safeFormat(new Date(), "EEEE, d 'de' MMMM", { locale: ptBR });
  
  // Capitalizar primeira letra do dia da semana
  const todayCapitalized = today.charAt(0).toUpperCase() + today.slice(1);
  
  const userName = appUser?.first_name || appUser?.display_name?.split(' ')[0] || 'usuário';
  
  return (
    <div className="mb-6">
      <h1 className="text-2xl md:text-3xl font-bold text-foreground">
        {isLoading ? (
          <span className="animate-pulse">Carregando...</span>
        ) : (
          `${greeting}, ${userName}!`
        )}
      </h1>
      <p className="text-muted-foreground mt-1">
        {todayCapitalized}
      </p>
    </div>
  );
}
